import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

/**
 * Renders Avery's replies, which use light Markdown (bold/italic, line breaks, the odd
 * list). react-markdown escapes HTML by default, so model output can't inject markup.
 * Styling lives in the `.md` class (styles/index.css) since Tailwind preflight strips
 * default emphasis/list rendering.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{children}</ReactMarkdown>
    </div>
  );
}
